<template>
    <div>
        <b-table
            striped
            hover
            :items="items"
            :fields="fields"
            show-empty
            :current-page="currentPage"
            :per-page="CONSTANTS.ITEM_PER_PAGE"
        >
            <template #cell(index)="data">{{
                (currentPage - 1) * CONSTANTS.ITEM_PER_PAGE + (data.index + 1)
            }}</template>
            <template v-slot:cell(userId)="row">
                <span>{{ userName[row.value] }}</span>
            </template>
            <template #cell(createdAt)="data">
                <span>{{ data.value | formatDateTime }}</span>
            </template>
            <template #cell(actions)="row">
                <b-button
                    variant="link"
                    class="mr-1 min-width-none"
                    style="color: white; background: #4dbd74;"
                    v-b-tooltip.hover
                    title="Tải xuống"
                    :href="getFilePath(row.item.path)"
                    target="_blank"
                >
                    <i class="fa fa-download"></i>
                </b-button>
                <!-- <b-button
                    variant="info"
                    @click="showUpdateModal(row.item)"
                    v-b-tooltip.hover
                    class="mr-1 min-width-none"
                    :title="$t('common.edit')"
                >
                    <i class="fa fa-pencil"></i>
                </b-button> -->
                <b-button
                    variant="danger"
                    @click="confirmDelete(row.item.id)"
                    v-b-tooltip.hover
                    class="min-width-none"
                    :title="$t('common.delete')"
                >
                    <i class="fa fa-trash"></i>
                </b-button>
            </template>
            <template v-slot:empty>
                <div class="text-center">
                    <span>Không có bản ghi nào</span>
                </div>
            </template>
        </b-table>
        <div v-if="countRow > CONSTANTS.ITEM_PER_PAGE" class="my-1">
            <b-pagination
                v-model="currentPage"
                :total-rows="countRow"
                :per-page="CONSTANTS.ITEM_PER_PAGE"
                :hide-goto-end-buttons="true"
                :prev-text="$t('common.prevPage')"
                :next-text="$t('common.nextPage')"
                class="my-0"
                align="center"
            />
        </div>

        <!-- Edit Info -->
        <b-modal
            ref="createOrUpdateModal"
            :ok-title="$t('common.update')"
            :title="'Cập nhật văn bản chỉ đạo'"
            :cancel-title="$t('common.cancel')"
            @ok="handleCreateOk"
            no-close-on-esc
            no-close-on-backdrop
            size="lg"
        >
            <b-form-group :label="$t('common.name')">
                <b-form-input
                    maxlength="255"
                    v-model="itemInfo.title"
                    :placeholder="$t('common.name')"
                />
            </b-form-group>
            <b-form-group label="Nội dung">
                <b-form-textarea
                    rows="6"
                    v-model="itemInfo.description"
                    placeholder="Mô tả"
                />
            </b-form-group>
            <b-form-group label="Tệp đính kèm">
                <b-link
                    :href="getFilePath(itemInfo.path)"
                    target="_blank"
                    class="ml-1 text-danger"
                >
                    <i class="fa fa-file-text"/>
                    {{itemInfo.path ? itemInfo.path.replace('/', '') : ''}}
                </b-link>
            </b-form-group>
        </b-modal>

        <!-- Confirm Delete -->
        <b-modal
            ref="deleteModal"
            :title="$t('common.confirmation')"
            no-close-on-esc
            no-close-on-backdrop
            :ok-title="$t('common.delete')"
            :cancel-title="$t('common.cancel')"
            ok-variant="danger"
            @ok="onDelete"
            >Bạn có chắc chắn muốn xoá văn bản chỉ đạo này?</b-modal
        >
    </div>
</template>
<script>
import { mapActions, mapState } from 'vuex';
import CONSTANTS from '@/constants';
import API_CONFIG from '@/api-config';
export default {
    computed: {
        ...mapState({
            items: (state) => state.news.listDocs,
            listUsers: (state) => state.user.users
        }),
        countRow() {
            return this.items.length;
        },
        userName() {
            const user = {};
            this.listUsers.forEach((element) => {
                user[element.id] = element.name;
            });
            return user;
        }
    },
    data() {
        return {
            fields: [
                { tdClass: 'align-middle', key: 'index', label: '#' },
                {
                    tdClass: 'align-middle',
                    thClass: 'title-long-col',
                    key: 'title',
                    label: this.$i18n.t('common.name')
                },
                { tdClass: 'align-middle', key: 'description', label: 'Nội dung' },
                { tdClass: 'align-middle', key: 'userId', label: 'Người tạo' },
                {
                    tdClass: 'align-middle',
                    thClass: 'date-col-width',
                    key: 'createdAt',
                    label: this.$i18n.t('common.lastCreated')
                },
                {
                    thClass: 'docs-action-col',
                    key: 'actions',
                    label: this.$i18n.t('common.actions')
                }
            ],
            itemInfo: {},
            currentId: null,
            currentPage: 1,
            CONSTANTS
        };
    },
    methods: {
        ...mapActions({
            getListDocs: 'news/getListDocs',
            updateDocs: 'news/updateDocs',
            deleteById: 'news/deleteDoc',
            downloadDoc: 'news/downloadDoc',
            createAuditByUser: 'user/createAuditByUser'
        }),
        async handleCreateOk(modal) {
            modal.preventDefault();
            const formData = new FormData();
            formData.append('title', this.itemInfo.title);
            formData.append('title', this.itemInfo.title);
            formData.append('title', this.itemInfo.title);
            const payload = {
                id: this.itemInfo.id,
                formData
            };
            await this.updateOrCreate(payload);
            this.$refs.createOrUpdateModal.hide();
            this.$toaster.success('Cập nhật văn bản chỉ đạo thành công');
            this.createAuditByUser({ content: 'Cập nhật văn bản chỉ đạo' });
        },
        async showUpdateModal(item) {
            this.resetForm();
            this.itemInfo = { ...item };
            this.$refs.createOrUpdateModal.show();
        },
        async onDelete(modal) {
            modal.preventDefault();
            await this.deleteById({ id: this.currentId });
            if (this.items.length / this.CONSTANTS.ITEM_PER_PAGE === this.currentPage - 1) {
                this.currentPage--;
            }
            this.$refs.deleteModal.hide();
            this.$toaster.success('Xoá văn bản chỉ đạo thành công!');
            this.createAuditByUser({ content: 'Xoá văn bản chỉ đạo' });
        },
        async confirmDelete(zoneId) {
            this.currentId = zoneId;
            this.$refs.deleteModal.show();
        },
        resetForm() {
            this.itemInfo = {};
        },
        getFilePath(path) {
            return `${API_CONFIG.BASE_URL}/document${path}`;
        }
    },
    async mounted() {
        await this.$nextTick();
        this.getListDocs();
    }
};
</script>
<style lang="scss">
.date-col-width {
    max-width: 150px;
    min-width: 150px;
    width: 150px;
}
.title-long-col {
    max-width: 200px;
    min-width: 200px;
    width: 200px;
}
</style>